import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { BlockWidths } from '../../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from '../blockMutualStyle';
import { useTheme } from '../../../theming/useTheme';
import { baseUnit } from '../../../theming/baseUnitDefinition';
import { RelatedPostsThemeProps, componentConfigThemeKey } from './relatedPosts.theme';
import { useViewabilityHandler } from '../../../viewability/viewabilityHandler';

export interface RelatedPostsWrapperProps {
  defaultBlocksWidths: BlockWidths;
  marginBetweenBlocksFactor: number;
  dataId: string;
}

const createWrapperStyle = (defaultBlocksWidths: BlockWidths, backgroundColor: string, marginBetweenBlocksFactor: number) => StyleSheet.create({
  style: {
    backgroundColor,
    marginTop: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    marginBottom: `${marginBetweenBlocksFactor * baseUnit * 2}px`,
    ...createBlockStyle(defaultBlocksWidths),
  },
}).style;

export const RelatedPostsWrapper: React.FunctionComponent<RelatedPostsWrapperProps> = props => {
  const viewabilityCallback = React.useCallback(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || [];
    // @ts-ignore
    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'related posts viewable impression',
      event_label: '',
    });
  }, []);

  const ref = useViewabilityHandler(viewabilityCallback, 0.5);
  const { defaultBlocksWidths, marginBetweenBlocksFactor, children, dataId } = props;
  const { backgroundColor } = useTheme<RelatedPostsThemeProps>(componentConfigThemeKey);
  const wrapperStyle = createWrapperStyle(defaultBlocksWidths, backgroundColor, marginBetweenBlocksFactor);
  return (
    <aside ref={ref} className={css(wrapperStyle)} data-mm-id={dataId}>
      {children}
    </aside>
  );
};
